import Modal from "../components/Modal";

export default class ProductSpecialOrder {
  constructor(section) {
    const triggers = section.el.querySelectorAll('.modal-trigger');
    const overlay = section.el.querySelector('#modal-overlay');

    triggers.forEach(trigger => {
      const modalId = trigger.dataset.modalId;
      const container = section.el.querySelector(`.modal-container[data-modal-id="${modalId}"]`);
      new Modal(trigger, container, overlay);
    });
  }
}
